import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import AppError from 'utils/AppError';
import api from 'services/api';

import Select from 'components/Select/withoutForm';
import Button from 'components/Button';

import { Chamada, Usuario } from 'pages/@types';

import { ComunicadorModal } from './styles';
import { useModal } from 'hooks/modal';

interface Props {
  setChamadas: React.Dispatch<React.SetStateAction<Chamada[]>>;
  selectedId: React.RefObject<number>;
}

export default function Comunicador(props: Props) {
  const [comunicadores, setComunicadores] = useState([]);
  const [loadingComunicadores, setLoadingComunicadores] = useState(false);
  const [selected, setSelected] = useState(false);

  const comunicadorId = useRef(0);
  const { showModal, hideModal } = useModal();
  const handleSubmit = useCallback(async () => {
    if (comunicadorId.current === 0) {
      toast.error('Comunicador não selecionado');
      return;
    }
    try {
      setLoadingComunicadores(true);

      const response = await api.patch(
        `/chamadasts/${props.selectedId.current}/comunicador`,
        {
          comunicador_id: comunicadorId.current,
        },
      );
      if (response && response.data && response.data.message === 'success') {
        props.setChamadas(prevState =>
          prevState.map(p =>
            p.id === props.selectedId.current
              ? {
                  ...p,
                  comunicador: response.data.chamada.comunicador,
                }
              : p,
          ),
        );
        toast.success('Comunicador associado');
      } else {
        toast.error('Falha ao associar comunicador');
      }
      hideModal();
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        const appError = error as AppError;
        toast.error(appError.message);
      }
    }
    setLoadingComunicadores(false);
    setSelected(prevState => !prevState);
    comunicadorId.current = 0;
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    async function loadComunicadores() {
      setLoadingComunicadores(true);
      try {
        const response = await api.get('/usuarios', {
          params: { locucao: true },
        });
        if (response && response.data) {
          setComunicadores(
            response.data.docs.map((comunicador: Usuario) => ({
              ...comunicador,
              value: comunicador.id,
              label: comunicador.nome,
              isDisabled: comunicador.status === 'inativo',
            })),
          );
        }
      } catch (error) {
        if (error instanceof Error) {
          toast.error(error.message);
        } else {
          const appError = error as AppError;
          toast.error(appError.message);
        }
      } finally {
        setLoadingComunicadores(false);
      }
    }
    loadComunicadores();
    return () => {
      controller.abort();
    };
  }, []);

  return (
    <ComunicadorModal>
      <div>
        <Select
          errorField=""
          type="avatar"
          name="comunicador"
          placeholder="Selecione o comunicador ..."
          options={comunicadores}
          key={`my_unique_select_key__${selected}`}
          onChange={comunicador => {
            comunicadorId.current = comunicador.id;
          }}
          isSearchable
          isClearable={false}
          disabled={loadingComunicadores}
          fill={false}
        />
      </div>
      <div>
        <Button type="submit" color="primary" onClick={() => handleSubmit()}>
          CONFIRMAR
        </Button>
      </div>
    </ComunicadorModal>
  );
}
